module.exports = __webpack_public_path__ + "img/settings.9f1ec55b.svg";